export const apiUrl = {
    nodeApi:{
        getCountry: "/api/getCountry",
        getJobtitle: "/api/getJobtitle",
        UserRegister: "/api/UserRegister",
        getHonorificId: "/api/getHonorificId",
        getDepartment: "/api/getDepartment",
        downloadWordFileHistroy:"/api/downloadWordFileHistroy",
        getWordArticleReportDownloadDetail: "/api/getWordArticleReportDownloadDetail",
        getEmailAvailability: "/api/EmailAvailability",
        getWordFileHistroy: "/api/getWordFileHistroy",
        updateWordflowReviewerInviteStatus: "/api/updateWordflowReviewerInviteStatus",
        saveLanguageEditorDownloadHistory: "/api/saveLanguageEditorDownloadHistory",
        insertLanguageEditorUpload: "/api/insertLanguageEditorUpload",
        PasswordReset: "/api/PasswordReset",
        updateLanguageEditorAction: "/api/updateLanguageEditorAction",
        insertReviewerReport: "/api/insertReviewerReport",
        userLogin: "/api/login",
        GetRoleByEmail: "/api/GetRoleByEmail",
        userForgotPassword: "/api/ForgotPassword",
        getJournalTitle: "/api/getJournalId",
        getArticleType: "/api/getArticleType",
        uploadArticle: "/api/uploadArticle",
        getSubmitArticleList: "/api/getSubmitArticleList",
        getSubmitArticleStatus: "/api/getIpubEditAutomationStatus",
        getmetadataList: "/api/getInitialArticleMetaData",
        putmetadata:"/api/updateArtilceMetaData",
        getAuthorLink:"/api/iauthorlinkCreate",
        getArticleReportDownloadUrl:"/api/getArticleReportDownloadUrl",
        getStagesList: "/api/getstages",
        getReviewerStages: "/api/getReviewerStages",
        getLinkByGuid:"/api/getLinkByGuid",
        getStageWiseCount:"/api/getStageWiseCount",
        getusermenu:"/api//getusermenu",
        getUserRoles:"/api/getUserRoles",
        UserProfileUpdate:"/api/UserProfileUpdate",
        saveAddressToReceiveHardCopy: "/api/saveAddressToReceiveHardCopy",
        getArticleListForDashboard:"/api/getArticleListForDashboard",
        getArticleStageHistory:"/api/getArticleStageHistory",
        GetAllUsers:"/api/GetAllUsers",
        MultipleUserRegister:"/api/MultipleUserRegister",
        deleteUser:"/api/deleteUser",
        getNotification:"/api/getNotification",
        getJournalAgainstUser:"/api/getJournalAgainstUser",
        getAuthorNameForManuscriptSummary:"/api/getAuthorNameForManuscriptSummary",
        getdataByUserId:"/api/getdataByUserId",
        getReviewerList:"/api/getReviewerList",
        getLangEditorList:"/api/getLangEditorList",
        getReviewerListByJournalId:"/api/getReviewerListByJournalId",
        addAddtitionalReviewerApi:"/api/addAddtitionalReviewerApi", 
        getPdfLinkByActivity:"/api/getPdfLinkByActivity",
        getPdfForLanguageEditor:"/api/getPdfForLanguageEditor",
        updateArticle:"/api/updateArticle",
        getReviewerReport: "/api/getReviewerReport",
        updateArtileTitle: "/api/updateArtileTitle",
        insertReviewerInviteStatus: "/api/insertReviewerInviteStatus",
        updateReviewerInviteStatusFromLink: "/api/updateReviewerInviteStatusFromLink",
        getartilceguid  : "/api/getartilceguid",
        getReviewerLink: "/api/getReviewerLink",
        getReviewerSubmit: "/api/getReviewerSubmit",
        getArticleActivityId: "/api/getArticleActivityId",
        submitReviewer: "/api/submitReviewer",
        GetResetLinkData: "/api/GetResetLinkData",
        getAllIssues: "/api/getAllIssues",
        getAllJournalsByUserId: "/api/getAllJournalsByUserId",
        getAllIssueByJournalId: "/api/getAllIssueByJournalId",
        selectE2EMainAuthors: "/api/selectE2EMainAuthors",
        getAuthorByArticleId: "/api/getAuthorByArticleId",
        insertE2EAuthorInfo: "/api/insertE2EAuthorInfo",
        updateE2EAuthorInfo: "/api/updateE2EAuthorInfo",
        deactivateE2EAuthor: "/api/deactivateE2EAuthor",
        insertSupplementFiles: "/api/insertSupplementFiles",
        getSupplementFilesByArticleId: "/api/getSupplementFilesByArticleId",
        getEditorApprovedArticleList: "/api/getEditorApprovedArticleList",
        getIssueArticleByJournalIdAndIssueId: "/api/getIssueArticleByJournalIdAndIssueId",
        insertIssueArticleDetails: "/api/insertIssueArticleDetails",
        deleteSupplementaryFile: "/api/deleteSupplementaryFile",
        downloadSupplementoryFile: "/api/downloadSupplementoryFile",
        postDataToE2E: "/api/postDataToE2E",
        moveToUnAllocatedData: "/api/moveToUnAllocatedData",
        getAllocatedArticleCountByJournalIdAndIssueId: "/api/getAllocatedArticleCountByJournalIdAndIssueId",
        getEmailAvailabilityInAuthorInfo: "/api/getEmailAvailabilityInAuthorInfo",
        getAuthorinfo: "/api/getAuthorinfo",
        deleteArticleById: "/api/deleteArticleById",
        getReviewerNotification:"/api/getReviewerNotification",
        getArticleName:"/api/getArticleName",
        getReviewerLastActivityId:"/api/reviewerLastActivityId",
        revokedAccess:"/api/revokedAccess",
        getTagsList: "/api/getTagsList",
        ipubEditAutomationStatusUpdate:"/api/ipubEditAutomationStatusUpdate",
        autostructuringFailed:"/api/autostructuringFailed",
        gethtmlDownloadByActivityId:"/api/gethtmlDownloadByActivityId",
        EmailAvailabilityrolebased: "/api/EmailAvailabilityrolebased",
        
    }
}



